"use client";

import { createStyles, Header, Container, rem } from "@mantine/core";
import Link from "next/link";
import Image from 'next/image';

export const HEADER_HEIGHT = rem(74);

const useStyles = createStyles((theme) => ({
  inner: {
    height: HEADER_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

const CHeader = ({ children, burger }) => {
  const { classes } = useStyles();

  return (
    <>
      <div className="h-4 bg-primary"></div>
      <Header height={HEADER_HEIGHT} className="my-5 border-0">
        <Container className={classes.inner}>
          <div className="flex items-center">
            {burger ?? <></>}
            <Link href={'/'}>
              <Image width={172} height={70} src="/images/logo.png" alt="Million Experts" />
            </Link>
          </div>
          {children}
        </Container>
      </Header>
    </>
  );
};

export default CHeader;
